import { Component, OnInit } from '@angular/core';
import { AppNameEnum, Betriebstaette, BetriebstaettenAngaben } from '@nachdigal';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComponentHelper, WithStammdatenIndex, WizardListPageBaseComponent } from '@utils-lib';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'common-ui-betriebstaetten-angaben',
    templateUrl: './betriebstaetten-angaben.component.html',
    styleUrls: ['./betriebstaetten-angaben.component.scss']
})
export class BetriebstaettenAngabenComponent extends WizardListPageBaseComponent<BetriebstaettenAngaben> implements OnInit {

    static nutzdatenPath = 'betriebstaettenAngaben';
    static route = 'betriebstaetten-angaben';
    public maxTelefonnummern = 1;
    public showSpecial = false;

    constructor(
        protected readonly activatedRoute: ActivatedRoute,
        private readonly router: Router,
        private readonly translateService: TranslateService) {
        super(activatedRoute);
        this.maxAllowed = 10;
        this.showSpecial = this.activatedRoute.parent?.snapshot.data.document.element_of_order.app_name === AppNameEnum.FragebogenKapGAus;
    }

    public ngOnInit(): void {
        super.ngOnInit();
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenPersG || appEnum === AppNameEnum.FragebogenKapGAus) {
            this.maxTelefonnummern = 1;
        }

        const stammdatenLength = this.stammdaten?.unternehmen?.betriebstaetten?.length;
        if (stammdatenLength > this.maxAllowed) {
            this.showMaxLimitHint = true;
        }
        if (!this.data.betriebstaetten) {
            this.data.betriebstaetten = [];
            const pageIsTouched = !!this.activatedRoute.parent?.snapshot.data.taskData.metadaten.pages.betriebstaettenAngaben.touched;
            if (stammdatenLength !== 0 && !pageIsTouched) {
                for (let i = 0; i < stammdatenLength && i < this.maxAllowed; i++) {
                    this.fillBetriebstaetteFromStammdaten(cloneDeep(this.stammdaten.unternehmen.betriebstaetten[i]));
                }
            }
        }
    }

    public addBetriebstaette(): void {
        this.data.betriebstaetten.push({
            bezeichnung: this.translateService.instant('COMMON_UI.FRAGEBOGEN.BETRIEBSTAETTEN.NEUE_BETRIEBSTAETTE')
        });
        this.selectedIndex = this.data.betriebstaetten.length - 1;
    }

    public removeBetriebstaette(index: number): void {
        this.data.betriebstaetten.splice(index, 1);
    }

    public onBetriebstaettePicked(betriebstaette: WithStammdatenIndex<Betriebstaette>): void {
        this.fillBetriebstaetteFromStammdaten(betriebstaette);
        this.selectedIndex = this.data.betriebstaetten.length - 1;
    }

    public fillBetriebstaetteFromStammdaten(betriebstaette: WithStammdatenIndex<Betriebstaette>): void {
        const current = {
            bezeichnung: betriebstaette.value.bezeichnung,
            inlandsadresse: betriebstaette.value.inlandsadresse,
            auslandsadresse: betriebstaette.value.auslandsadresse,
            kommunikationsmittel: betriebstaette.value.kommunikationsmittel,
            addressFest: betriebstaette.value.addressFest,
            eigentum: betriebstaette.value.eigentum,
            stammdatenIndex: betriebstaette.stammdatenIndex
        };
        this.data.betriebstaetten.push(current);
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([]);
    }

}
